import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { InputComponent } from '../../shared/ui/input/input.component';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { SelectData } from '../../shared/type/input';
import { ContentComponent } from '../../contents/content/content.component';
import { SpinnerService } from '../../../core/services/spinner.service';
import { Subscription } from 'rxjs';
import { ContentUpdateService } from '../services/content-update.service';
import { Content, ContentResponse } from '../../contents/type/content';
import { DataLayerService } from '../../../core/services/data-layer.service';

@Component({
  selector: 'app-content-search',
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    InputComponent,
    ReactiveFormsModule,
    ContentComponent,
  ],
  providers: [],
  templateUrl: './content-search.component.html',
  styleUrl: './content-search.component.scss',
})
export class ContentSearchComponent implements OnDestroy {
  screenName = this._dataLayerService.screen_name ?? '';
  searchForm!: FormGroup;
  contenData!: Content[] | [];
  subscription: Subscription = new Subscription();

  contentTypeList!: SelectData[];
  stateList!: SelectData[];
  defaultValueSelect = { value: 'TODOS', label: 'Todos' };

  firstloadPage: boolean = true;

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly _managementService: ContentUpdateService,
    private readonly _spinnerService: SpinnerService,
    private readonly _dataLayerService: DataLayerService
  ) {}

  ngOnInit(): void {
    this.searchForm = this._formBuilder.group({
      public: [this.defaultValueSelect.value, [Validators.required]],
      state: [this.defaultValueSelect.value, [Validators.required]],
    });

    this._initValues();
  }

  _initValues(): void {
    this.contentTypeList = this._managementService.contentTypeSearchData;
    this.stateList = this._managementService.statusContentSearchData;
    this.getContent();
  }

  onSearch(): void {
    this.firstloadPage = false;

    let params = Object.entries(this.searchForm.value)
      .filter(([key, value]) => value !== this.defaultValueSelect.value)
      .map(([key, value]) => {
        if (key === 'public') {
          return `${key}=${value === 'privado' ? 'false' : 'true'}`;
        }
        return `${key}=${value}`;
      })
      .join('&');

    params = params ? `?${params}` : '';
    this._dataLayerService.pushEventSearch(
      this.screenName,
      'content-search',
      params.replace('?', '')
    );
    this.getContent(params);
  }

  buttonOn(): boolean {
    if (this.firstloadPage) {
      return !(
        this.searchForm.value.state !== this.defaultValueSelect.value ||
        this.searchForm.value.contentType !== this.defaultValueSelect.value
      );
    } else {
      return false;
    }
  }

  getContent(params?: string): void {
    this._spinnerService.show();
    const sub = this._managementService.getManageContents(params).subscribe({
      next: (response) => {
        const contentResponse: ContentResponse = response;
        this.contenData = contentResponse.contents;
      },
      error: (err) => {
        this._spinnerService.hide();
      },
      complete: () => {
        this._spinnerService.hide();
      },
    });
    this.subscription.add(sub);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
